import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';

export interface SvcCheck { found: boolean; serviceable: boolean; oda: boolean; pincode?: string }

/**
 * Checks whether the selected courier serves a destination pincode (and whether it's ODA).
 * Only runs when both a courier and a 6-digit pincode are present. Unknown (courier, pincode)
 * pairs return { found:false, serviceable:true } so we never falsely warn.
 */
export function useServiceabilityCheck(courierId: string | number | undefined | null, pincode: string | undefined | null) {
  const pin = String(pincode ?? '').replace(/\D/g, '').slice(0, 6);
  const cid = courierId ? Number(courierId) : 0;
  return useQuery({
    queryKey: ['svc-check', cid, pin],
    queryFn: async () => (await api.get('/serviceability/pincode-check', { params: { courierId: cid, pincode: pin } })).data as SvcCheck,
    enabled: !!cid && pin.length === 6,
    staleTime: 60_000,
    retry: false,
  });
}
